import { BaseError } from './BaseError'

/**
 * Error types that the {@link GenericError} can be.
 *
 * @remarks
 * - 'MESSAGE_NOT_RECEIVED': Listener extension did not receive to the message.
 * - 'NOT_RESPONDING': Listener extension received the message but did not respond.
 * - 'EXTENSION_ID_NOT_ALLOWED': The extension ID of the controller is not allowed by the listener.
 * - 'NOT_LOGGED_IN': The listener extension is not logged-in.
 */
export type GenericErrorType =
  | 'MESSAGE_NOT_RECEIVED'
  | 'NOT_RESPONDING'
  | 'EXTENSION_ID_NOT_ALLOWED'
  | 'NOT_LOGGED_IN'

/**
 * Generic error that most actions can return.
 */
export class GenericError extends BaseError {
  type: GenericErrorType

  /**
   * Creates an instance of GenericError.
   * @param type - GenericError type.
   * @param extensionVersion - Version of the extension where the error occurred.
   * @param message - Error message.
   */
  constructor(
    type: GenericErrorType,
    extensionVersion: string | undefined = undefined,
    message: string = ''
  ) {
    super(message, extensionVersion)
    this.type = type

    Object.setPrototypeOf(this, GenericError.prototype)
    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'GenericError' })
  }
}
